<template>
  <div class="">
    <div class="head-title">参数配置</div>
    <el-collapse style="margin-bottom: 2.0rem">
      <el-collapse-item title="帮助文档" name="1">
        <div class="help">
          <p>
            1、线索跟进天数是对无标签客户线索等级的默认划分。
            例如：在此设置为3天，若没有及时跟进线索将自动掉入线索公海。
          </p>
          <p>
            2、客户跟进天数是对录入客户线索时选择无等级客户的默认划分。
            例如：在此设置为3天，若没有及时跟进此客户将自动掉入客户公海。
          </p>
          <p>
            3、客户未成交天数是对录入客户线索时选择无等级客户的默认划分。
            例如：在此设置为3天，若没有及时成交此客户将自动掉入客户公海。
          </p>
          <p>
            4、信封提醒时间的设置是提前提醒成员跟进线索/客户资源的时间设置。例如：在此设置为1小时，系统将会提醒成员1小时后需要跟进的线索/客户资源，并在前端信封提醒中展示该线索。
          </p>
          <p>5、在此设置在员工端是否启用、删除、编辑等功能，</p>
          <p>
            6、启用锁定线索功能以后，员工在添加客户的微信以后拉取到的线索池中的状态是锁定状态，锁定状态的线索不会掉入线索池中。
            <a
              class="help-link"
              href="https://www.weijub.com/index/index/news_detail?id=123"
              target="_blank"
              rel="noopener noreferrer"
              >使用教程</a
            >
          </p>
        </div>
      </el-collapse-item>
    </el-collapse>
    <div class="">
      <div class="mMain">
        <div class="">
          <el-form
            ref="form"
            :model="data"
            label-width="14.0rem"
            label-position="right"
          >
            <el-form-item label="线索跟进天数">
              <el-input
                clearable
                v-model="data.tableData.leads_follow_days"
                style="width: 54rem"
                >></el-input
              >
            </el-form-item>
            <el-form-item label="客户跟进天数">
              <el-input
                clearable
                v-model="data.tableData.customer_follow_days"
                style="width: 54rem"
                >></el-input
              >
            </el-form-item>
            <el-form-item label="客户未成交天数">
              <el-input
                clearable
                v-model="data.tableData.customer_deal_days"
                style="width: 54rem"
                >></el-input
              >
            </el-form-item>
            <el-form-item label="信封提醒时间(h)">
              <el-input
                clearable
                v-model="data.tableData.warning_time"
                style="width: 54rem"
                >></el-input
              >
            </el-form-item>
            <el-form-item label="获取通话时长密钥">
              <el-input
                clearable
                type="textarea"
                autosize="true"
                v-model="data.tableData.secret_key"
                style="width: 54rem"
                >></el-input
              >
            </el-form-item>
            <el-form-item label="查看线索范围(km)">
              <el-input
                clearable
                v-model="data.tableData.range"
                style="width: 54rem"
                >></el-input
              >
            </el-form-item>
            </el-form>
            <el-form
            class="form-switch"
            style="width:72.0rem;"
            ref="form"
            :model="data"
            label-width="14.0rem"
            label-position="right"
            :inline="true">
            <el-form-item label="启用线索池">
              <el-switch
                v-model="data.tableData.leads_config"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
            <el-form-item label="启用客户池" class="two-switch">
              <el-switch
                v-model="data.tableData.customer_config"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
            <el-form-item label="启用锁定线索">
              <el-switch
                v-model="data.tableData.if_lock"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
            <el-form-item label="是否允许删除线索" class="two-switch">
              <el-switch
                v-model="data.tableData.leads_delete"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
            <el-form-item label="是否允许删除客户">
              <el-switch
                v-model="data.tableData.customer_delete"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
            <el-form-item label="是否允许删除联系人" class="two-switch">
              <el-switch
                v-model="data.tableData.contracts_delete"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
            <el-form-item label="是否允许删除商机">
              <el-switch
                v-model="data.tableData.business_delete"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
            <el-form-item label="是否允许编辑跟进记录" class="two-switch">
              <el-switch
                v-model="data.tableData.if_edit_record"
                :active-value="1"
                :inactive-value="0"

              ></el-switch>
            </el-form-item>
          </el-form>
        </div>
        <el-button type="primary" @click="onSubmit">确定</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
export default {
  data() {
    return {
      data: {
        tableData: {},
      },
      msg: "2",
      radio: "1",
      username: "",
      title: {},
      tooken: "",
    };
  },
  mounted() {
    // 页面刷新就请求到数据渲染到页面中
    // get请求页面的数据 http://192.168.0.149/api/Prive/getPriveList
    if (window.localStorage.getItem("storuser")) {
      let userinfo = JSON.parse(window.localStorage.getItem("storuser"));
      // // // console.log(userinfo);
      this.tooken = userinfo;
    }
    this.about();
  },
  methods: {
    // 提交过后输出的数据\
    toggleStatuss() {
      this.axios
        .post(
          "/crm/CrmConfig/addCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            leads_config: this.data.tableData.leads_config,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
        })
        .catch(function (err) {});
    },
    toggleStatus() {
      this.axios
        .post(
          "/crm/CrmConfig/addCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            customer_config: this.data.tableData.customer_config,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
        })
        .catch(function (err) {});
    },
    about() {
      this.axios
        .post(
          "/crm/CrmConfig/getCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          if (res.data.msg == "登录超时") {
            this.$router.push("/register");
          }
          if (res.data.code == 0) {
            this.data.tableData == {};
          } else if (res.data.code == 1) {
            this.data.tableData = res.data.data;
          }
        })
        .catch(function (err) {});
    },
    onSubmit() {
      this.axios
        .post(
          "/crm/CrmConfig/addCrmConfig",
          qs.stringify({
            usertoken: this.tooken.usertoken,
            account_id: this.tooken.account_id,
            phone: this.tooken.phone,
            leads_follow_days: this.data.tableData.leads_follow_days,
            customer_follow_days: this.data.tableData.customer_follow_days,
            secret_key: this.data.tableData.secret_key,
            range: this.data.tableData.range,
            leads_delete: this.data.tableData.leads_delete,
            customer_delete: this.data.tableData.customer_delete,
            contracts_delete: this.data.tableData.contracts_delete,
            business_delete: this.data.tableData.business_delete,
            leads_config: this.data.tableData.leads_config,
            customer_config: this.data.tableData.customer_config,
            if_edit_record: this.data.tableData.if_edit_record,
            warning_time: this.data.tableData.warning_time,
            if_lock: this.data.tableData.if_lock,
            customer_deal_days: this.data.tableData.customer_deal_days,
          }),
          {
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          }
        )
        .then((res) => {
          this.about();
          if (res.data.msg == "登录超时") {
            this.$router.push("/Tagent");
          }
          if (res.data.code == 1) {
            this.$message({
              message: res.data.msg,
              type: "success",
            });
          } else if (res.data.code == 0) {
            this.$message.error(res.data.msg);
          }
        })
        .catch(function (err) {});
    },
  },
  // 1.用户分配
  // 2.用户分配
  //3.用户选择 附件管理
};
</script>
<style scoped>
.home {
  width: 100%;
  height: 100%;
}
.body_html {
  width: 100%;
  height: 100%;
}
.wei_body {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  box-shadow: .0rem .1rem .6rem .0rem rgba(0, 0, 0, 0.2);
  padding: 2.3rem 3.1rem;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia {
  width: 100%;
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
}
.tianjia > main {
  font-size: 2.3rem;
}
.bule {
  width: 100%;
  height: 6.9rem;
  background-color: #2890dd;
  z-index: 10;
  position: absolute;
  top: .0rem;
  left: .0rem;
}
/* */
.mMain{
  padding:3.0rem;
}
.el-form-item{
  margin-bottom:4.0rem;
}
::v-deep .el-form-item__label{
  padding: .0rem ;
  margin-right:2.0rem;
  font-size:1.6rem ;
}
/* .form-switch .el-form-item__label:nth-child(2n){
  width:55.0rem;
} */
::v-deep .two-switch .el-form-item__label{
  width:43.0rem !important;
}
</style>


